/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2017, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
// This file is used to create the require layers. Only the entry points are necessary
define([
	'./Absolute',
	'./GenericPage',
	'./Group',
	'./ScalingAbsolute',
	'./Tab',
	'./TemplateContainer',
	'./TemplateDropZone',
	'./TemplateIndicator',
	'./Widget'
], function() {

});
